const FRESH_LOGIN_KEY = 'ollaa_partner_fresh_login';
const SHOWN_DATE_PREFIX = 'ollaa_partner_community_behavior_';

export const COMMUNITY_BEHAVIOR_MODAL_TITLE = 'Community-Verhalten';

export const COMMUNITY_BEHAVIOR_SECTIONS = [
  {
    id: 'greeting',
    text: 'Mitglieder begrüßen uns + Service-Team mit einem freundlichen „Ollaa [Olá]"',
    intro: true,
  },
  {
    id: 'appreciation',
    title: 'Wertschätzung / Service',
    text: 'Wir bedanken uns, sind aufmerksam, & freundlich zu Mitgliedern & Partnern.',
  },
  {
    id: 'cleanliness',
    title: 'Sauberkeit',
    text: 'Vermeiden starken Lärm, Gerüche & achten auf ein stets sauberes Lokal.',
  },
  {
    id: 'quality',
    title: 'Anhaltende Qualität',
    text: 'Service & Rücksicht + Frische, Qualität & Präsentation der Ware sind wichtig.',
  },
  {
    id: 'accuracy',
    title: 'Richtige Angaben',
    text: 'Hausregeln, Speißekarte/ Preise, Öffnungszeiten & Online-Angaben sind aktuell.',
  },
];

export const COMMUNITY_BEHAVIOR_ANIMATION_MS = 8000;

const storageKeyForCompany = (companyId) => `${SHOWN_DATE_PREFIX}${companyId}`;

const todayKey = () => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
};

export function markFreshLogin() {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(FRESH_LOGIN_KEY, '1');
  } catch (e) {
    console.warn('markFreshLogin:', e);
  }
}

export function consumeFreshLogin() {
  if (typeof window === 'undefined') return false;
  try {
    const isFresh = sessionStorage.getItem(FRESH_LOGIN_KEY) === '1';
    if (isFresh) sessionStorage.removeItem(FRESH_LOGIN_KEY);
    return isFresh;
  } catch {
    return false;
  }
}

export function peekFreshLogin() {
  if (typeof window === 'undefined') return false;
  try {
    return sessionStorage.getItem(FRESH_LOGIN_KEY) === '1';
  } catch {
    return false;
  }
}

export async function getCommunityBehaviorLastShownDate(companyId) {
  if (!companyId) return null;
  try {
    return localStorage.getItem(storageKeyForCompany(companyId));
  } catch {
    return null;
  }
}

export async function markCommunityBehaviorShownToday(companyId) {
  if (!companyId) return;
  try {
    localStorage.setItem(storageKeyForCompany(companyId), todayKey());
  } catch {
    // ignore quota / private mode errors
  }
}

export async function shouldShowCommunityBehaviorOnDailyLogin(companyId) {
  if (!companyId) return false;
  if (!peekFreshLogin()) return false;
  const lastShown = await getCommunityBehaviorLastShownDate(companyId);
  return lastShown !== todayKey();
}
